"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CSPMonitor = /*#__PURE__*/function () {
  function CSPMonitor() {
    _classCallCheck(this, CSPMonitor);
  }

  _createClass(CSPMonitor, null, [{
    key: "register",
    value:
    /* istanbul ignore next */
    function register() {
      if (!('document' in global) || !document.addEventListener) {
        return;
      }

      if (CSPMonitor.shouldRegisterCSPMonitor) {
        if (!CSPMonitor.added) {
          document.addEventListener('securitypolicyviolation', CSPMonitor.listener);
          CSPMonitor.added = true;
        }
      }
    }
    /* istanbul ignore next */

  }, {
    key: "unregister",
    value: function unregister() {
      if (!('document' in global) || !document.removeEventListener) {
        return;
      }

      document.removeEventListener('securitypolicyviolation', CSPMonitor.listener);
      CSPMonitor.loggers = new Set();
      CSPMonitor.added = false;
    }
  }, {
    key: "disable",
    value: function disable() {
      CSPMonitor.shouldRegisterCSPMonitor = false;
      CSPMonitor.unregister();
    }
  }, {
    key: "addLogger",
    value: function addLogger(logger) {
      if (logger) {
        CSPMonitor.loggers.add(logger);
      }
    }
  }, {
    key: "removeLogger",
    value: function removeLogger(logger) {
      if (logger) {
        CSPMonitor.loggers.delete(logger);
      }
    }
  }]);

  return CSPMonitor;
}();

exports.default = CSPMonitor;
CSPMonitor.loggers = new Set();
CSPMonitor.shouldRegisterCSPMonitor = true;
CSPMonitor.added = false;
/* istanbul ignore next */

CSPMonitor.listener = function (event) {
  var message = 'Security Policy Violation\n' + "Blocked URI: ".concat(event.blockedURI, "\n") + "Violated Directive: ".concat(event.violatedDirective, "\n") + "Original Policy: ".concat(event.originalPolicy, "\n") + "Document URI: ".concat(event.documentURI, "\n") + "Source File: ".concat(event.sourceFile, "\n") + "Line No.: ".concat(event.lineNumber, "\n");

  var _iterator = _createForOfIteratorHelper(CSPMonitor.loggers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var logger = _step.value;
      logger.error(message);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (CSPMonitor.loggers.size === 0) {
    console.error(message);
  }
};